module.exports = __webpack_public_path__ + "img/fb.653dfcd3.svg";